export const FORM_NAME = 'employee-category';
